import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

import type { ContractApiResponse } from '../../services/contract-services';

interface FullyPaidContractsPanelProps {
    fullyPaidContracts: ContractApiResponse[];
    /** True when the payment table above is rendering rows — controls this panel's top border radius. */
    hasPaymentRows: boolean;
}

/** Warning panel listing contracts that are fully paid (shown below the payment table). */
export const FullyPaidContractsPanel: React.FC<FullyPaidContractsPanelProps> = ({
    fullyPaidContracts,
    hasPaymentRows,
}) => {
    return (
        <Box
            sx={{
                mt: 4,
                mb: 3,
                borderRadius: hasPaymentRows ? '0 0 10px 10px' : 2,
                borderTop: `2px solid ${colors.successPreset[50]}`,
                overflow: 'hidden',
                bgcolor: colors.greyPreset[5],
            }}
        >
            {/* Header */}
            <Stack direction="row" alignItems="center" gap={1} sx={{ px: 2, py: 1.5 }}>
                <span className="icon-info-filled" style={{ fontSize: 16, color: colors.successPreset[50] }} />
                <Typography variant="body2" fontWeight={700} sx={{ color: colors.successPreset[50] }}>
                    Below contracts are fully paid
                </Typography>
            </Stack>
            {/* Contract cards grid */}
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5,
                    px: 2,
                    pb: 2,
                }}
            >
                {fullyPaidContracts.map(contractItem => {
                    const contractId = contractItem.AspireId || `Contract ${contractItem.Id}`;
                    return (
                        <Box
                            key={contractId}
                            sx={{
                                bgcolor: 'white',
                                borderRadius: 2,
                                px: 2,
                                py: 1.5,
                                flex: '1 1 100px',
                                maxWidth: 180,
                            }}
                        >
                            <Typography variant="body2" fontWeight={500} sx={{ color: colors.greyPreset[80], mb: 0.5 }}>
                                {contractId}
                            </Typography>
                            <Typography variant="caption" sx={{ color: colors.successPreset[50], fontWeight: 600 }}>
                                ✓ Fully Paid
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};
